import { render, staticRenderFns } from "./clientInt.vue?vue&type=template&id=a7ce1366&scoped=true&"
import script from "./clientInt.vue?vue&type=script&lang=js&"
export * from "./clientInt.vue?vue&type=script&lang=js&"
import style0 from "./clientInt.vue?vue&type=style&index=0&id=a7ce1366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ce1366",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
